import { Box, type BoxProps } from "@chakra-ui/react";
import React from "react";

type GradientBorderProps = {
  bg: BoxProps["bg"];
  gradient?: BoxProps["bgGradient"];
} & Omit<BoxProps, "bg">;

export function GradientBorder({ children, bg, gradient = "linear(to-r, mint, cyan)", ...props }: GradientBorderProps) {
  return (
    <Box borderRadius="lg" bgGradient={gradient} pos="relative" p="1px" overflow="hidden">
      <Box borderRadius="lg" bg={bg} {...props}>
        {children}
      </Box>
    </Box>
  );
}
